const style = {
  copyToClipboardIcon: {
    color: '#EC0982',
    cursor: 'pointer',
    fontSize: '1vw',
    marginTop: '3px',
  },
} as const;

export default style;
